<template>
  <section v-if="isEditing" class="tomas-booking tomas-booking-shop container">
    <div>TODO</div>
  </section>
</template>

<script lang="ts" setup>
const { isEditing } = defineBlokkliFragment({
  name: 'ostendis_jobs',
  label: 'Ostendis Jobs',
  chunkName: 'rare',
  editor: {
    noPreview: true,
  },
})
</script>
